import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
export var TooltipTrigger = function (_a) {
    var children = _a.children, triggerRef = _a.triggerRef, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return (_jsx("div", { className: styles.trigger, ref: triggerRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children }));
};
